module.exports = __webpack_public_path__ + "img/3ds-max.9510c17c.png";